"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOC_TYPE_TO_POLISH_TYPE = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const material_1 = require("@mui/material");
const AutoFixHigh_1 = __importDefault(require("@mui/icons-material/AutoFixHigh"));
const hooks_1 = require("../../../hooks");
const api_1 = require("../../../api");
exports.DOC_TYPE_TO_POLISH_TYPE = {
    [api_1.DOC_TYPE.FORM]: "form",
    [api_1.DOC_TYPE.PDF]: "pdf",
    [api_1.DOC_TYPE.PPT]: "ppt", // polish API expects "ppt", not "pptx"
    [api_1.DOC_TYPE.WORD]: "docx",
};
const PolishPrompt = ({ text, onPolish, docType }) => {
    const { showNotification } = (0, hooks_1.useNotifier)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const handlePolish = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!text.trim()) {
            showNotification("Nothing to polish. Please enter text.", "warning");
            return;
        }
        try {
            setLoading(true);
            const res = yield fetch("https://dev.crm.image.marktine.com/explain_prompt/", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    type: exports.DOC_TYPE_TO_POLISH_TYPE[docType],
                    prompt: text,
                }),
            });
            if (!res.ok)
                throw new Error("Failed to polish text");
            const data = yield res.json();
            // ✅ Adjust to API response format
            if (!(data === null || data === void 0 ? void 0 : data.response))
                throw new Error("Invalid response from API");
            onPolish(data.response);
            showNotification("Prompt polished successfully!", "success");
        }
        catch (err) {
            console.error("❌ Polish error:", err);
            showNotification(err.message || "Something went wrong", "error");
        }
        finally {
            setLoading(false);
        }
    });
    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: "Polish Prompt", children: (0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(material_1.IconButton, { size: "small", onClick: handlePolish, disabled: loading || !text.trim(), children: loading ? (0, jsx_runtime_1.jsx)(material_1.CircularProgress, { size: 16 }) : (0, jsx_runtime_1.jsx)(AutoFixHigh_1.default, {}) }) }) }));
};
exports.default = PolishPrompt;
